import { ESTIMATE_COPIED } from './actionTypes';

export default (originalId, copyId, containerMap) => ({
  type: ESTIMATE_COPIED,
  payload: { originalId, copyId, containerMap },
});
